import React from "react";

export default function Hearth({ classes }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.741"
      height="30.945"
      viewBox="0 0 34.741 30.945"
      className={classes}
    >
      <g id="hearts-suit" transform="translate(1.37 1.252)">
        <g id="Group_153" dataname="Group 153">
          <path
            id="Path_85"
            dataname="Path 85"
            d="M31.683,17.221,18,31.441,4.314,17.221A8.423,8.423,0,1,1,18,7.743a8.423,8.423,0,1,1,13.684,9.479Z"
            transform="translate(-1.998 -2.998)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.5"
          />
        </g>
      </g>
    </svg>
  );
}
